import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { EndpointsService } from './endpoints.service';
import { firstValueFrom, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Auth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private _count = 0;

  get count() {
    return this._count;
  }

  constructor(
    private httpService: HttpService,
    private endpoints: EndpointsService,
    private auth: Auth,
  ) { }

  list(userId: string): Observable<any> {
    return this.httpService.get(this.endpoints.notificationList.replace('{userId}', userId))
      .pipe(
        map((notifications: any) => {
          let count = 0;
          notifications.data.forEach((notification: any) => {
            if (notification.status.id == 1) {
              count++;
            }
          })
          this._count = count;
          return notifications;
        })
      );
  }

  seen(notificationId: string, seen: boolean) {
    if (!seen) {
      this._count--;
    }
    return this.httpService.put(this.endpoints.notificationSeen.replace('{notificationId}', notificationId));
  }

  async delete(notificationId: string) {
    await firstValueFrom(this.httpService.delete(this.endpoints.notificationDelete.replace('{notificationId}', notificationId)));
  }

  sendNewSale(businessId:number,business:string,saleId:number){
    return this.httpService.post(`${environment.mapache.hosts.notifications}/push/web`, {
      "userId": this.auth.currentUser!.uid,//profile usuario app
      "businessId": businessId,// negocio id
      "business": business, //firebase id
      "saleId": saleId, //venta id
      "body": "Dirijete a la sección de Compras y actualizala para ver más información",
      "subject": "¡Hey! ¡tienes una nueva venta!"
  });
  }
}
